import React from "react";

import { observer } from "mobx-react";
import PropTypes from "prop-types";

import Vacancy from "../SearchResults/Vacancy";

function DefaultSingleJob(props) {
  const { showHead, applyButtonPosition, applyButtonText } = props;

  return (
    <Vacancy
      applyButtonPosition={applyButtonPosition}
      applyButtonText={applyButtonText}
      showHead={showHead}
      singleJobView
    />
  );
}

export default observer(DefaultSingleJob);

DefaultSingleJob.propTypes = {
  applyButtonPosition: PropTypes.string,
  applyButtonText: PropTypes.string,
  showHead: PropTypes.bool,
};

DefaultSingleJob.defaultProps = {
  applyButtonPosition: undefined,
  applyButtonText: undefined,
  showHead: undefined,
};
